import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';

import React, { useEffect, useState } from 'react';

const AddQuestion = ({ setQuestion, question, setDisable }) => {
  const [errors, setErrors] = useState([]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setQuestion((prev) => ({ ...prev, [id]: value }));
  };

  const validateInputs = () => {
    const newErrors = [];
    if (!question.title) newErrors.push('Assignment Title is required.');
    if (!question.question) newErrors.push('Question Text is required.');
    if (!question.dueDate) newErrors.push('Question Due Date is required.');

    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  };

  useEffect(() => {
    validateInputs();
  }, [question]);

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="pb-[5px] pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Practical Assignment Details :
      </h4>

      <InputField
        extra="mb-3"
        label="Practical Assignment Title"
        placeholder="Enter Assignment Title"
        id="title"
        type="text"
        value={question?.title}
        onChange={handleInputChange}
      />

      <InputField
        extra="mb-3"
        label="Due  Date"
        placeholder="Enter Assignment Title"
        id="dueDate"
        type="date"
        value={question?.dueDate}
        onChange={handleInputChange}
      />

      <div className="mt-5">
        <TextField
          extra="mb-3"
          label="Question Text"
          placeholder="Enter Question Text"
          id="question"
          type="text"
          value={question?.question}
          onChange={handleInputChange}
        />
      </div>

      {/* Error Messages */}
      {errors.length > 0 && (
        <div className="mt-4 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddQuestion;
